<template>
  <div id="app">
    <router-view/>
    <Modal
        title="提示信息"
        width="300"
        v-model="errorMsg.show">
      <p>{{errorMsg.content}}</p>
      <p v-if="errorMsg.errorUrl" style="margin-top: 10px;"><a :href="errorMsg.errorUrl" target="_blank">点击下载错误信息</a></p>
      <div slot="footer">
        <Button type="primary" size="large" @click="redirectLogin">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {}
  },
  created () {
  },
  computed: {
    errorMsg () {
      return this.$store.state.dialogErrorMessage;
    }
  },
  methods: {
    redirectLogin () {
      this.$store.commit('distoryErrorDialog');
    }
  }
}
</script>
<style lang="less">
  @import "./assets/styles/base";
  .kh-layout-header {
    padding: 0 10px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue